import { apiFetch } from './api';
import type { UserDevice } from '../types/models';

export interface RankInfo {
  rank: number | null;
  totalUsers: number;
  avgHealthPct: number | null;
}

export async function listMine(): Promise<UserDevice[]> {
  const res = await apiFetch<{ userDevices: UserDevice[] }>('/me/devices');
  return res.userDevices;
}

export async function getMyRank(): Promise<RankInfo> {
  return apiFetch<RankInfo>('/me/devices/rank');
}

export async function addUserDevice(payload: {
  deviceId: string;
  nickname?: string;
  purchasedAt?: string;
  batteryHealthPct?: number;
  notes?: string;
}): Promise<UserDevice> {
  const res = await apiFetch<{ userDevice: UserDevice }>('/me/devices', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return res.userDevice;
}

export async function updateUserDevice(
  id: string,
  patch: Partial<Pick<UserDevice, 'nickname' | 'batteryHealthPct' | 'notes' | 'purchasedAt'>>
): Promise<UserDevice> {
  const res = await apiFetch<{ userDevice: UserDevice }>(`/me/devices/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  return res.userDevice;
}

export async function removeUserDevice(id: string): Promise<void> {
  await apiFetch<void>(`/me/devices/${id}`, { method: 'DELETE' });
}
